/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnreadCountResponseDto
 */
export interface UnreadCountResponseDto {
    /**
     * Unread message count
     * @type {number}
     * @memberof UnreadCountResponseDto
     */
    count: number;
}

/**
 * Check if a given object implements the UnreadCountResponseDto interface.
 */
export function instanceOfUnreadCountResponseDto(value: object): value is UnreadCountResponseDto {
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function UnreadCountResponseDtoFromJSON(json: any): UnreadCountResponseDto {
    return UnreadCountResponseDtoFromJSONTyped(json, false);
}

export function UnreadCountResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnreadCountResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
    };
}

export function UnreadCountResponseDtoToJSON(json: any): UnreadCountResponseDto {
    return UnreadCountResponseDtoToJSONTyped(json, false);
}

export function UnreadCountResponseDtoToJSONTyped(value?: UnreadCountResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
    };
}

